import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageOfSlideShowBlockConfig } from '@front-platform/content-builder';
import { imageOfSlideShowBlockResolveConfig } from '@front-platform/content-builder';
import { map, takeUntil } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';
export interface ImageOfSlideShowBlockRuntimeConfig {}

export type ImageOfSlideShowBlockConfigInput = Partial<
  Omit<ImageOfSlideShowBlockConfig, keyof ImageOfSlideShowBlockRuntimeConfig> &
    ImageOfSlideShowBlockRuntimeConfig
>;
export type ImageOfSlideShowBlockResolvedConfig = Omit<
  ImageOfSlideShowBlockConfig,
  keyof ImageOfSlideShowBlockRuntimeConfig
> &
  Partial<ImageOfSlideShowBlockRuntimeConfig>;
export interface ImageOfSlideShowBlockContract extends ConfigComponentContract<
  ImageOfSlideShowBlockConfigInput,
  ImageOfSlideShowBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-of-slide-show-block',
  templateUrl: './image-of-slide-show-block.component.html',
  styleUrls: ['./image-of-slide-show-block.component.scss'],
  standalone: false,
})
export class ImageOfSlideShowBlockComponent
  extends DestroyerBase
  implements OnInit, ImageOfSlideShowBlockContract
{
  readonly config = input<ImageOfSlideShowBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageOfSlideShowBlockConfig,
    ImageOfSlideShowBlockRuntimeConfig
  >(imageOfSlideShowBlockResolveConfig, () => ({ config: this.config() }));
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get mobileImageSize(): string | undefined {
    return this.resolvedConfig()['mobile_image_size'] as unknown as string | undefined;
  }
  get desktopImageSize(): string | undefined {
    return this.resolvedConfig()['desktop_image_size'] as unknown as string | undefined;
  }

  imageWidthClass?: string;

  constructor(private settingsSelector: SettingsStoreSelector) {
    super();
  }

  ngOnInit(): void {
    this.settingsSelector.selectDeviceIsMobileScreen
      .pipe(
        takeUntil(this._destroyerRef),
        map(isMobile => {
          if (isMobile) {
            this.imageWidthClass =
              'w-' +
              (this.mobileImageSize !== 'full' ? this.mobileImageSize + '-screen' : 'screen');
          } else {
            this.imageWidthClass =
              'w-' +
              (this.desktopImageSize !== 'full' ? this.desktopImageSize + '-screen' : 'screen');
          }
        }),
      )
      .subscribe();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageOfSlideShowBlockComponent, { 'keyAliases': {} });
